import React from 'react'

import { Field } from 'formik'

import { Col, Form } from '_zari/core'

import { TiposDeCuentasContablesDeDosDigitos } from 'constants/index'

const CuentaFormGroup = ({ idFormato, iTouched, iError, fIsSubmitting, name, label }) => {
  return (
    <Form.Group>
      <Form.Label text={label || 'CUENTA'} htmlFor={`${idFormato}-input-mesContabilidad`} md={2} alignRightAt='md' />
      <Col md={10}>
        <Field name={name || 'cuenta'}>
          {({ field }) => (
            <Form.Select id='select-cuenta' fIsSubmitting={fIsSubmitting} iError={iError} iTouched={iTouched} {...field}>
              <option key='cuentasPorCobrar' value={TiposDeCuentasContablesDeDosDigitos.CUENTAS_POR_COBRAR}>
                {TiposDeCuentasContablesDeDosDigitos.__dictionary[TiposDeCuentasContablesDeDosDigitos.CUENTAS_POR_COBRAR].nombre}
              </option>
              <option key='efectivoyEquivalentes' value={TiposDeCuentasContablesDeDosDigitos.EFECTIVO_Y_EQUIVALENTES}>
                {TiposDeCuentasContablesDeDosDigitos.__dictionary[TiposDeCuentasContablesDeDosDigitos.EFECTIVO_Y_EQUIVALENTES].nombre}
              </option>
              <option key='cuentasPorCobraraAccionistas' value={TiposDeCuentasContablesDeDosDigitos.CUENTAS_POR_COBRAR_A_ACCIONISTAS}>
                {TiposDeCuentasContablesDeDosDigitos.__dictionary[TiposDeCuentasContablesDeDosDigitos.CUENTAS_POR_COBRAR_A_ACCIONISTAS].nombre}
              </option>
              <option key='cuentasPorCobrarDiversas' value={TiposDeCuentasContablesDeDosDigitos.CUENTAS_POR_COBRAR_DIVERSAS}>
                {TiposDeCuentasContablesDeDosDigitos.__dictionary[TiposDeCuentasContablesDeDosDigitos.CUENTAS_POR_COBRAR_DIVERSAS].nombre}
              </option>
              <option key='tributosContraprestacionesyAportes' value={TiposDeCuentasContablesDeDosDigitos.TRIBUTOS_CONTRAPRESTACIONS_Y_APORTES}>
                {TiposDeCuentasContablesDeDosDigitos.__dictionary[TiposDeCuentasContablesDeDosDigitos.TRIBUTOS_CONTRAPRESTACIONS_Y_APORTES].nombre}
              </option>
              <option key='remuneracionesyParticipaciones' value={TiposDeCuentasContablesDeDosDigitos.REMUNERACIONES_Y_PARTICIPACIONES}>
                {TiposDeCuentasContablesDeDosDigitos.__dictionary[TiposDeCuentasContablesDeDosDigitos.REMUNERACIONES_Y_PARTICIPACIONES].nombre}
              </option>
              <option key='cuentasPorPagar' value={TiposDeCuentasContablesDeDosDigitos.CUENTAS_POR_PAGAR}>
                {TiposDeCuentasContablesDeDosDigitos.__dictionary[TiposDeCuentasContablesDeDosDigitos.CUENTAS_POR_PAGAR].nombre}
              </option>
              <option key='cuentasPorPagarDiversas' value={TiposDeCuentasContablesDeDosDigitos.CUENTAS_POR_PAGAR_DIVERSAS}>
                {TiposDeCuentasContablesDeDosDigitos.__dictionary[TiposDeCuentasContablesDeDosDigitos.CUENTAS_POR_PAGAR_DIVERSAS].nombre}
              </option>
            </Form.Select>
          )}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(CuentaFormGroup)
